export default __webpack_public_path__ + "static/media/26-min.f1d4ddbc.jpg";